import { Action } from '@ngrx/store';
import { ServiceGroup } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len

export const ADD_ACCEPTED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Add Accepted Service In State';
export class AddAcceptedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = ADD_ACCEPTED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { serviceGroup: any }) {}
}

export const REMOVE_ACCEPTED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Remove Accepted Service In State';
export class RemoveAcceptedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = REMOVE_ACCEPTED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { id: string }) {}
}

export const CLEAR_ACCEPTED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Clear Accepted Service In State';
export class ClearAcceptedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = CLEAR_ACCEPTED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type AcceptedServiceAction =
  | AddAcceptedServiceInState
  | RemoveAcceptedServiceInState
  | ClearAcceptedServiceInState;
